import { render, staticRenderFns } from "./TyreWCO.vue?vue&type=template&id=675aedfe"
import script from "./TyreWCO.vue?vue&type=script&lang=js"
export * from "./TyreWCO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports